export default __webpack_public_path__ + "media/images/carnival/destination_1_rj-8af048517c1b9ec0c9c4d11eac838ca8.jpg";